var colors = {
  black: {
    500: '#1D2729',
    400: '#273437',
    300: '#2F3E42',
    200: '#3A494D',
    100: '#4F5B5F'
  },
  red: {
    500: '#9D2F3A',
    400: '#A3444D',
    300: '#B25B63',
    200: '#C2777E',
    100: '#D9959B'
  },
  white: {
    500: '#FFFFFF',
    400: '#ECF5F7',
    300: '#E1E2E4',
    200: '#D8D8D8'
  },
  purple: {
    500: '#674AA9',
    400: '#7153B5',
    300: '#8063C2',
    200: '#9376D5',
    100: '#A689E9'
  },
  orange: {
    500: '#CB5623',
    400: '#D95B24',
    300: '#E66C37',
    200: '#F28252',
    100: '#F69F79'
  },
  yellow: {
    500: '#E29B1E',
    400: '#F0AB30',
    300: '#FBBC57',
    200: '#FFD898',
    100: '#FFE7C2'
  },
  green: {
    500: '#487650',
    400: '#578760',
    300: '#6C9A74',
    200: '#85AB8B',
    100: '#9CC0A2'
  },
  gray: {
    500: '#CDCFD3',
    400: '#E1E2E4',
    300: '#EDEDED',
    200: '#F2F2F2',
    100: '#F5F5F5'
  },
  pink: {
    500: '#F4A083',
    400: '#F4AD94',
    300: '#F7BCA7',
    200: '#F6C9B9',
    100: '#FADACE'
  },
  lightBlue: {
    500: '#85B4C3',
    400: '#8FC2D3',
    300: '#A2D3E3',
    200: '#B7E3F1',
    100: '#C9ECF8'
  },
  blue: {
    500: '#27566D',
    400: '#31627A',
    300: '#44748C',
    200: '#5989A2',
    100: '#77A3BB'
  }
};

export { colors };
//# sourceMappingURL=index.esm.js.map
